import { render } from "./SaveCustomField.vue?vue&type=template&id=327a4b22&scoped=true"
import script from "./SaveCustomField.vue?vue&type=script&lang=js"
export * from "./SaveCustomField.vue?vue&type=script&lang=js"

import "./customField.scss?vue&type=style&index=0&id=327a4b22&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327a4b22"]])

export default __exports__